import { Box } from "@mui/material";
import useAPI from "../../../../../api/hooks/useAPI";
import useColors from "../../../../../api/hooks/useColors";
import CustomToolTip from "../../../../../components/CustomTooltip";
import { TrackingEventType } from "../../../../../utils/constants";
import IntegrationImage from "../../../integrations/components/IntegrationImage";
import { IntegrationsMapping } from "../../../integrations/IntegrationsMapping";

const SourcesListSection = ({ selectedEntity }) => {
  const { trackEvent } = useAPI();
  const colors = useColors();

  const handleClick = (tool, deepLink, entityTypeForTracking) => {
    if (deepLink) {
      trackEvent(
        `User clicked on deep link for ${entityTypeForTracking} in ${IntegrationsMapping[tool].displayName}: ${deepLink}`,
        {
          event_type: TrackingEventType.TOOL_DEEP_LINK_CLICKED,
          tool: tool,
          entity_type: entityTypeForTracking,
          deep_link: deepLink,
        }
      );
      window.open(deepLink, "_blank");
    } else if (entityTypeForTracking) {
      // If there is no deep link, track the event only if entity type for tracking is provided
      trackEvent(
        `User clicked on integration image with no deep link for ${entityTypeForTracking} in ${IntegrationsMapping[tool].displayName}`
      );
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        gap: "8px",
      }}
    >
      {selectedEntity?.sources?.map((source, index) => {
        const hasDeepLink =
          source !== "breeze" &&
          selectedEntity?.origin_platform_deep_link?.[source];
        const tooltipTitle = hasDeepLink
          ? "View in " + IntegrationsMapping[source].displayName
          : IntegrationsMapping[source].displayName;

        return (
          <CustomToolTip title={tooltipTitle} key={index} placement="top">
            <Box
              onClick={() =>
                handleClick(
                  source,
                  hasDeepLink
                    ? selectedEntity?.origin_platform_deep_link?.[source]
                    : null,
                  selectedEntity?.entity_type
                )
              }
              sx={{
                borderRadius: "5px",
                width: "32px",
                height: "32px",
                backgroundColor: colors.common_white,
                alignItems: "center",
                display: "flex",
                position: "relative",
                justifyContent: "center",
                boxShadow: "0px 0px 2px 0px " + colors.black_24percent,
                cursor: hasDeepLink ? "pointer" : "default",
              }}
            >
              <IntegrationImage
                name={source}
                width={"24px"}
                showToolTip={false}
                newLogo={true}
              />
            </Box>
          </CustomToolTip>
        );
      })}
    </Box>
  );
};

export default SourcesListSection;
